import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../app/store';

interface FeatureFlags {
  isExperimentalFeaturesModalOpen: boolean;
}

const initialState: FeatureFlags = {
  isExperimentalFeaturesModalOpen: false,
};

export const featureFlagSlice = createSlice({
  name: 'experimental',
  initialState,
  reducers: {
    toggleFeatureFlagsModal: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isExperimentalFeaturesModalOpen: action.payload,
      };
    },
  },
});

export const { toggleFeatureFlagsModal } = featureFlagSlice.actions;

export const selectIsFeatureFlagsModalOpen = (state: RootState) => {
  return state.experimental.isExperimentalFeaturesModalOpen;
};

export const { reducer: experimentalReducer } = featureFlagSlice;
